import { render, staticRenderFns } from "./list-notifications.vue?vue&type=template&id=5b1f2c13&scoped=true&"
import script from "./list-notifications.vue?vue&type=script&lang=js&"
export * from "./list-notifications.vue?vue&type=script&lang=js&"
import style0 from "./list-notifications.vue?vue&type=style&index=0&id=5b1f2c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f2c13",
  null
  
)

export default component.exports